import { ActionTree } from 'vuex';
import LanguageService from '@/services/LanguageService';
import { TranslationsState, RootState } from '@/types/state';
import StaticTranslationsService from '@/services/StaticTranslationsService';
import { StaticTranslation, UnsavedStaticTranslation, StaticTranslationInterface } from '@/types/translations';

const actions: ActionTree<TranslationsState, RootState> = {
  loadLanguages(context): Promise<void> {
    return new Promise((resolve, reject) => {
      LanguageService.fetchAll()
        .then((languages) => {
          context.commit('setLanguages', languages);
          resolve();
        }).catch(reject);
    });
  },

  loadTranslationKeys(context): Promise<void> {
    return new Promise((resolve, reject) => {
      StaticTranslationsService.fetchKeys().then((keys) => {
        context.commit('setTranslationKeys', keys);
        resolve();
      }).catch(reject);
    });
  },

  loadTranslations(context): Promise<StaticTranslation[]> {
    return new Promise((resolve, reject) => {
      StaticTranslationsService.fetchAll()
        .then((translations) => {
          context.commit('setStaticTranslations', translations);
          context.commit('setStaticTranslationsLoaded');
          resolve(translations);
        }).catch(reject);
    });
  },

  addTranslation(context, translation: UnsavedStaticTranslation): Promise<StaticTranslation> {
    return new Promise((resolve, reject) => {
      StaticTranslationsService.create(translation)
        .then((savedTranslation) => {
          context.commit('addStaticTranslation', savedTranslation);
          resolve(savedTranslation);
        }).catch(reject);
    });
  },

  updateTranslation(context, translation: StaticTranslationInterface): Promise<StaticTranslation> {
    return new Promise((resolve, reject) => {
      StaticTranslationsService.update(translation)
        .then((updatedTranslation) => {
          context.commit('updateStaticTranslation', updatedTranslation);
          resolve(updatedTranslation);
        }).catch(reject);
    });
  },

  deleteTranslation(context, translation: StaticTranslationInterface): Promise<void> {
    return new Promise((resolve, reject) => {
      StaticTranslationsService.delete(translation)
        .then((deletedTranslation) => {
          context.commit('deleteStaticTranslation', deletedTranslation);
          resolve();
        }).catch(reject);
    });
  },

};

export default actions;
